// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Menu from 'components/menu/menu'
import NowPlaying from 'components/NowPlaying/NowPlaying'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'

const logoTextSVG = siteData.images_url + 'logo/faithfm-r4.svg'

class HeaderPrimary extends React.Component {
	render() {
		const { isMobile } = this.props

		return (
			<header className="header">
				<div className="header-top">
					<div className="logo">
						<Link to="/">
							<img className="site-logo" src={ logoTextSVG } alt="" />
						</Link>
					</div>

					{ ! isMobile &&
						<ErrorBoundary>
							<NowPlaying />
						</ErrorBoundary>
					}
				</div>
			</header>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isMobile: state.site.isMobile
	}
}

export default connect( mapStateToProps )( HeaderPrimary )
